import { IsNumber } from 'class-validator';
import { GiftCardTransactionDto } from '../../dto/gift-card/giftCardTransaction.dto';
import { EntityTypeIdEnum } from '../../enum/entity-type-id.enum';

export class GiftCardTransactionRequest {
  transactions: GiftCardTransactionDto[];

  @IsNumber()
  entityId: number;

  entityTypeId: EntityTypeIdEnum;
}
